import React, { useState, useEffect, useRef, forwardRef, Fragment } from "react";
import {TextField,
        Grid,
        InputAdornment,
        Box,
        Button,
        CircularProgress,
        Switch,
        Typography,
        Dialog,
        DialogActions,
        DialogContent,
        DialogContentText,
        DialogTitle,
        IconButton,
        NativeSelect,
        InputLabel,
        FormControl,
        MenuItem
} from "@material-ui/core";
import {DropzoneArea} from 'material-ui-dropzone'
import { Link } from '../../components/Wrappers'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import PhoneIcon from '@material-ui/icons/Phone';
import SmartphoneIcon from '@material-ui/icons/Smartphone';
import EmailIcon from '@material-ui/icons/Email';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import PublishIcon from '@material-ui/icons/Publish';
import GetAppIcon from '@material-ui/icons/GetApp';
import DeleteIcon from '@material-ui/icons/Delete';
import HistoryIcon from '@material-ui/icons/History';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import DescriptionIcon from '@material-ui/icons/Description';

import enNZ from 'date-fns/locale/en-NZ'
import DatePicker, { registerLocale } from "react-datepicker";
import useStyles from './styles';
import ttAPI from '../../api/ttAPI';
import config from '../../config';
import classnames from "classnames";
import Widget from '../../components/Widget';
import AddressAutoComplete from '../../components/AddressAutoComplete/AddressAutoComplete';
import CustomerUpdatePricingWithCPI from '../../components/CustomerUpdatePricingWithCPI/CustomerUpdatePricingWithCPI';
import CustomerPolicyEditor from './CustomerPolicyEditor';

//import SelectCustomerServices from './SelectCustomerServices';
import SelectCustomerTestingScopes from './SelectCustomerTestingScopes';
import CustomProperties from '../CustomProperties/CustomProperties';
import { sendNotification } from "../../context/UserContext";
import './CustomerComponent.css'
import './Pricing.css'
import './Industry.css'
import './SelectCustomerTestingScopes.css'
import "react-datepicker/dist/react-datepicker.css";


registerLocale('en-NZ', enNZ);

const UpdateCustomer = forwardRef((props, ref) => {
    // global
    const { onUpdateSuccess } = props
    const classes = useStyles();
    const [newCustomer, setNewCustomer] = useState({...props.createdCustomer});
    const [isSaving, setIsSaving] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [fileObjects, setFileObjects] = useState([]);
    const [isUploadingOther, setIsUploadingOther] = useState(false);
    const [fileObjectsOther, setFileObjectsOther] = useState([]);
    //const selectCustomerServicesRef = useRef(null);
    const selectCustomerTestingScopesRef = useRef(null);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [aboutToDeleteDoc, setAboutToDeleteDoc] = useState({id:0, name:''});
    const [isDeletingDocument, setIsDeletingDocument] = useState(false);
    const [otherDocumentsLimit, setOtherDocumentsLimit] = useState(2);
    const [selectedChargeBy, setSelectedChargeBy] = useState('Tag');
    const [selectedAgreementStartDate, setSelectedAgreementStartDate] = React.useState();
    const [selectedAgreementEndDate, setSelectedAgreementEndDate] = React.useState();
    const [selectedPriceChangeDate, setSelectedPriceChangeDate] = React.useState();

    const customerPricingWidgetRef = useRef(null);
    const agreementStartDateRef = useRef(null);
    const agreementStartDateCalendarRef = useRef(null);
    var currentAgreementStartDateValue = null;
    const [agreementStartDateFocused, setAgreementStartDateFocused] = React.useState(false);

    const agreementEndDateRef = useRef(null);
    const agreementEndDateCalendarRef = useRef(null);
    var currentAgreementEndDateValue = null;
    const [agreementEndDateFocused, setAgreementEndDateFocused] = React.useState(false);

    const priceChangeDateRef = useRef(null);
    const priceChangeDateCalendarRef = useRef(null);
    var currentPriceChangeDateValue = null;
    const [priceChangeDateFocused, setPriceChangeDateFocused] = React.useState(false);

    const customerUpdatePricingWithCPIRef = useRef(null);
    const pricingWidgetRef = useRef(null);

    const [industryCategories, setIndustryCategories] = useState([]);
    const [customerPolicyDialogOpen, setCustomerPolicyDialogOpen] = useState(false);

    useEffect(() => {
      async function loadIndustryCategories() {
        const response = await ttAPI.getIndustryCategories();
        setIndustryCategories(response || []);
      }

      loadIndustryCategories();
    }, []);

    useEffect(() => {
      if (agreementStartDateCalendarRef !== undefined && agreementStartDateCalendarRef !== null &&
        agreementStartDateCalendarRef.current !== undefined && agreementStartDateCalendarRef.current !== null) {
        agreementStartDateCalendarRef.current.setOpen(agreementStartDateFocused);
      }
    },[agreementStartDateFocused]);

    useEffect(() => {
      if (agreementEndDateCalendarRef !== undefined && agreementEndDateCalendarRef !== null &&
        agreementEndDateCalendarRef.current !== undefined && agreementEndDateCalendarRef.current !== null) {
        agreementEndDateCalendarRef.current.setOpen(agreementEndDateFocused);
      }
    },[agreementEndDateFocused]);

    useEffect(() => {
      if (priceChangeDateCalendarRef !== undefined && priceChangeDateCalendarRef !== null &&
        priceChangeDateCalendarRef.current !== undefined && priceChangeDateCalendarRef.current !== null) {
        priceChangeDateCalendarRef.current.setOpen(priceChangeDateFocused);
      }
    },[priceChangeDateFocused]);

    useEffect(() => {

        if(newCustomer.documents !== undefined && newCustomer.documents !== null) {
            var limit = newCustomer.documents === undefined || newCustomer.documents === null ? 2 : (newCustomer.documents.length >= 2 ? 0 : (2-newCustomer.documents.length));
            setOtherDocumentsLimit(limit);
        }

        if (newCustomer.hourly_charge !== null && newCustomer.hourly_charge !== undefined && newCustomer.hourly_charge > 0) {
            setSelectedChargeBy('Hour');
        }
        else {
            setSelectedChargeBy('Tag');
        }

        if (newCustomer.agreement_start_date !== undefined && newCustomer.agreement_start_date !== null && newCustomer.agreement_start_date !== '') {
              var d1 = new Date(newCustomer.agreement_start_date);
              setSelectedAgreementStartDate(d1);
        }

        if (newCustomer.agreement_end_date !== undefined && newCustomer.agreement_end_date !== null && newCustomer.agreement_end_date !== '') {
              var d1 = new Date(newCustomer.agreement_end_date);
              setSelectedAgreementEndDate(d1);
        }

        if (newCustomer.price_change_date !== undefined && newCustomer.price_change_date !== null && newCustomer.price_change_date !== '') {
              var d1 = new Date(newCustomer.price_change_date);
              setSelectedPriceChangeDate(d1);
        }
    },[newCustomer]);

    async function refreshCustomer() {
      setNewCustomer(null);
      const response = await ttAPI.getCustomerById(newCustomer.id);
      setNewCustomer(response);
    }

   function handleChange(e) {
     setNewCustomer({
       ...newCustomer,
       [e.target.name]: e.target.value,
     });
   }


   function onSelectCustomerAddress(address) {
     setNewCustomer({
       ...newCustomer,
       address: address
     });
   }

   function onClickArchiveSwitch() {
       setNewCustomer({
         ...newCustomer,
         active: newCustomer.active === undefined || newCustomer.active === null ? false : !newCustomer.active
       });
   }

   function onClickAutoFailedReportSwitch() {
       setNewCustomer({
         ...newCustomer,
         auto_failed_report: newCustomer.auto_failed_report === undefined || newCustomer.auto_failed_report === null ? false : !newCustomer.auto_failed_report
       });
   }

   function onClickRequireVaccinationProofSwitch() {
       setNewCustomer({
         ...newCustomer,
         require_vaccination_proof: newCustomer.require_vaccination_proof === undefined || newCustomer.require_vaccination_proof === null ? false : !newCustomer.require_vaccination_proof
       });
   }

   function onClickPoRequiredSwitch() {
       setNewCustomer({
         ...newCustomer,
         po_required: newCustomer.po_required === undefined || newCustomer.po_required === null ? false : !newCustomer.po_required
       });
   }

   function onClickJSARequiredSwitch() {
       setNewCustomer({
         ...newCustomer,
         jsa_required: newCustomer.jsa_required === undefined || newCustomer.jsa_required === null ? false : !newCustomer.jsa_required
       });
   }

   function onClickMicrowaveOnlySwitch() {
       setNewCustomer({
         ...newCustomer,
         microwave_only: newCustomer.microwave_only === undefined || newCustomer.microwave_only === null ? false : !newCustomer.microwave_only
       });
   }

   function onClickServiceLevelAgreementSwitch() {
       setNewCustomer({
         ...newCustomer,
         service_level_agreement: !(newCustomer.service_level_agreement ?? false)
       });
   }

   function onClickKpiCustomerSwitch() {
        setNewCustomer({
          ...newCustomer,
          kpi_customer: !(newCustomer.kpi_customer ?? false)
        });
    }

    function onClickKeyCustomerSwitch() {
        setNewCustomer({
          ...newCustomer,
          key_customer: !(newCustomer.key_customer ?? false)
        });
    }

   function onGeoLocationFetched(geolocation) {
     setNewCustomer({
       ...newCustomer,
       mapurl: `https://maps.google.co.nz/maps?q=${geolocation.lat},${geolocation.lng}`
     });
   }

   const disableSaveButton = () => {
     if (!isSaving && props.isNotesOnly) {
       return false;
     }
     return isSaving || (newCustomer.name === undefined || newCustomer.name === null || newCustomer.name === '') ||
           ((newCustomer.service_level_agreement ?? false) && (newCustomer.agreement_start_date === undefined || newCustomer.agreement_start_date === null || newCustomer.agreement_start_date === '')) ||
           ((newCustomer.service_level_agreement ?? false) && (newCustomer.agreement_end_date === undefined || newCustomer.agreement_end_date === null || newCustomer.agreement_end_date === '')) ||
           (newCustomer.testing_scopes === undefined || newCustomer.testing_scopes === null || newCustomer.testing_scopes.length <= 0) ||
           (newCustomer.testing_scopes !== undefined && newCustomer.testing_scopes !== null && newCustomer.testing_scopes.length > 0 &&
             ((newCustomer.testing_scopes.find(item => item !== undefined && item !== null && (item.name !== undefined && item.name !== null && item.name.toLowerCase().includes('please make a note'))) !== undefined) &&
               (newCustomer.testing_scope_other_notes== undefined || newCustomer.testing_scope_other_notes === null || newCustomer.testing_scope_other_notes === '')));
   }

   const updateCustomer = async () => {
       setIsSaving(true);
       var customerToSave = newCustomer;
       /*if (customerToSave.services !== undefined && customerToSave.services !== null) {
           customerToSave.services = customerToSave.services.map(service => service.id);
       }*/
       if (customerToSave.testing_scopes !== undefined && customerToSave.testing_scopes !== null) {
           customerToSave.testing_scopes = customerToSave.testing_scopes.map(testing_scope => testing_scope.id === undefined ? testing_scope : testing_scope.id);
       }
       if (selectedChargeBy === 'Tag') {
           customerToSave.hourly_charge = 0;
       }
       else {
           if (customerToSave.hourly_charge === null || customerToSave.hourly_charge === undefined || customerToSave.hourly_charge <= 0) {
               customerToSave.hourly_charge = customerToSave.default_hourly_charge;
           }
       }

       if (customerToSave.service_level_agreement === null || customerToSave.service_level_agreement === undefined || !customerToSave.service_level_agreement) {
           customerToSave.agreement_start_date = null;
           customerToSave.agreement_end_date = null;
       }


       if (customerToSave.custom_properties === null || customerToSave.custom_properties === undefined || customerToSave.custom_properties === '') {
           customerToSave.custom_properties = null;
       }
       else {
           // make sure custom properties is stirngyified
           customerToSave.custom_properties = JSON.stringify(customerToSave.custom_properties);
       }

       if (customerToSave.industry_category_id === '') {
          customerToSave.industry_category_id = null;
        }

        if (customerToSave.target_tag_rate_per_hour === '') {
          customerToSave.target_tag_rate_per_hour = null;
        }


       if (props.isNotesOnly) {
         const response = await ttAPI.saveCustomerNotes(customerToSave);
         if (response.data !== undefined && response.data !== null && response.data.length > 0 && response.data[0].ok) {
           onUpdateSuccess();
           sendNotification('success', 'Success - Customer Notes Updated.', classes)
         }
         else {
           sendNotification('error', 'Error update customer notes.', classes)
         }
       }
       else {
         const response = await ttAPI.saveCustomer(customerToSave);
         if (response.data !== undefined && response.data !== null && response.data.length > 0 && response.data[0].ok) {
           onUpdateSuccess();
           sendNotification('success', 'Success - Customer Updated.', classes)
         }
         else {
           sendNotification('error', 'Error update customer.', classes)
         }
       }
       setIsSaving(false);
   }

   const onUploadSitePolicy = async () => {
       setIsUploading(true);
       if ( window.FileReader && window.FormData) {
          var formData = new FormData();
          var reader = new FileReader();
          // read
          reader.onload = async function(e) {
              var fileName = fileObjects[0].name;
              if (formData) {console.log(fileObjects[0]);
                  formData.append('files[]', fileObjects[0], fileName);
                  const response = await ttAPI.uploadSitePolicy(newCustomer.id, formData);
                  setIsUploading(false);
                  if (response) {
                    sendNotification('success', 'Success - Site Policy Uploaded.', classes);
                  }
                  else {
                    sendNotification('error', 'Error - Error Uploading Site Policy.', classes);
                  }
              }

          };
          reader.readAsDataURL(fileObjects[0]);
      }

   }

   const onUploadOtherDocuments = async () => {
       setIsUploadingOther(true);
       if ( window.FileReader && window.FormData) {
          var formData = new FormData();

          var fileExisted = newCustomer.documents !== undefined && newCustomer.documents !== null ?
                              newCustomer.documents.map(doc => doc.name) : [];

          var filesToUpload = fileObjectsOther.filter(fileToUpload => !fileExisted.includes(fileToUpload.name));
          for(var i=0;i<filesToUpload.length;i++){
              formData.append("file[]", filesToUpload[i], filesToUpload[i].name);
          }
          const response = await ttAPI.uploadOtherDocuments(newCustomer.id, formData);
          setIsUploadingOther(false);
          console.log(response);
          if (response) {
              onUpdateSuccess();
              sendNotification('success', 'Success - Other Documents Uploaded.', classes);
          }
          else {
              sendNotification('error', 'Error - Error Uploading Other Documents.', classes);
          }


      }

   }

   /*function onServicesSelected(services) {
       setNewCustomer({
         ...newCustomer,
         services: services,
       });
   }*/

   function onTestingScopesSelected(testingScopes) {
       setNewCustomer({
         ...newCustomer,
         testing_scopes: testingScopes,
       });
   }

   function onOtherTestingScopesSpecified(otherTestingScopeNotes) {
     setNewCustomer({
       ...newCustomer,
       testing_scope_other_notes: otherTestingScopeNotes,
     });
   }

   function onCustomerPropertiesChanged(customProperties) {
     setNewCustomer({
       ...newCustomer,
       custom_properties: customProperties,
     });
   }

   function onCustomPropertiesEnableChanged(customPropertiesEnabled) {
     setNewCustomer({
       ...newCustomer,
       enable_custom_properties: customPropertiesEnabled,
     });
   }

   function onDeleteDocument(id) {
       // check the file 'delete' is not an existing one on server...
       if (newCustomer.documents !== undefined && newCustomer.documents !== null && newCustomer.documents.length > 0)  {
         var fileExisted = newCustomer.documents.map(doc => doc.id);
         if(fileExisted.includes(id)) {
             // get ready to delete from server, confirm with user first
             var docToDelete = newCustomer.documents.filter(doc => doc.id === id)[0];
             setAboutToDeleteDoc({id: docToDelete.id,
                                  name: docToDelete.title});
             setOpenDeleteDialog(true);
         }
       }

   }

   const deleteDocument = async () => {
       const response = await ttAPI.deleteDocument(aboutToDeleteDoc.id);
       if (response.id > 0) {
           onUpdateSuccess();
           sendNotification('success', `Success - Document ${aboutToDeleteDoc.name} Deleted.`, classes);
           setOpenDeleteDialog(false);
       }
       else {
           sendNotification('error', `${response.error}`,classes);
       }
   }


   /*function getExistingOtherDocuments() {
     if (newCustomer.documents !== undefined && newCustomer.documents !== null && newCustomer.documents.length > 0) {
       var existingDocs = [];
       for (var i=0; i < newCustomer.documents.length; i++) {
           existingDocs.push(new File([`${config.clientApi}/dashboard/customer_documents?id=${newCustomer.documents[i].id}`],
                                      newCustomer.documents[i].title, {type: newCustomer.documents[i].type}));
       }
       console.log(existingDocs);
       return existingDocs;
     }
     return [];
   }*/

   function hideOtherDocumentsUploadButton() {
       return fileObjectsOther.length <= 0 || fileObjectsOther.length > 2 ;
   }

   const handleCloseDeleteDialog = () => {
     setOpenDeleteDialog(false);
   };

   function handleChangeSelectChargeBy(e) {
       setSelectedChargeBy(e.target.value);

       if (e.target.value === 'Tag') {
           setNewCustomer({
             ...newCustomer,
             hourly_charge: 0,
           });
       }
   }

   const downloadPricingHistory = () => {
     if (newCustomer.id === undefined) {
         sendNotification('error','Cannot download pricing history, invalid customer id');
     }
     else {
         window.open(`${config.clientApi}/reports/audit/pricing/customer?id=${newCustomer.id}`,'_blank');
     }


     customerPricingWidgetRef.current.closeWidgetMoreMenu();
   }

   function updateCustomerPricingWithCPI() {
     customerUpdatePricingWithCPIRef.current.openConfirmationPopup(newCustomer.id, newCustomer.name);
     customerPricingWidgetRef.current.closeWidgetMoreMenu();
   }

   // triggered if value changes, but not save anywhere as the value here can be in-progress (if use keyboard)
   function handleChangeAgreementStartDate(d) {
     currentAgreementStartDateValue = d;
   }

   function handleChangeAgreementEndDate(d) {
     currentAgreementEndDateValue = d;
   }

   function handleChangePriceChangeDate(d) {
     currentPriceChangeDateValue = d;
   }

   function focusAgreementStartDate(event) {
     setAgreementStartDateFocused(true);
   }

   function focusAgreementEndDate(event) {
     setAgreementEndDateFocused(true);
   }

   function focusPriceChangeDate(event) {
     setPriceChangeDateFocused(true);
   }

   function blurAgreementStartDate(event) {
     setAgreementStartDateFocused(false);
     saveAgreementStartDate();
   }

   function blurAgreementEndDate(event) {
     setAgreementEndDateFocused(false);
     saveAgreementEndDate();
   }

   function blurPriceChangeDate(event) {
     setPriceChangeDateFocused(false);
     savePriceChangeDate();
   }

   function openCustomerPolicyDialog() {
     setCustomerPolicyDialogOpen(true);
   }

   function closeCustomerPolicyDialog() {
     setCustomerPolicyDialogOpen(false);
   }

   // triggered if use keyboard
   function handleAgreementStartDateKeyPress(event) {
     if (event.which === 9 || event.which === 13 || event.which === 27) {
       setAgreementStartDateFocused(false);
       saveAgreementStartDate();
     }
   }

   function handleAgreementEndDateKeyPress(event) {
     if (event.which === 9 || event.which === 13 || event.which === 27) {
       setAgreementEndDateFocused(false);
       saveAgreementEndDate();
     }
   }

   function handlePriceChangeDateKeyPress(event) {
     if (event.which === 9 || event.which === 13 || event.which === 27) {
       setPriceChangeDateFocused(false);
       savePriceChangeDate();
     }
   }

   // triggered if select a date
   function handleSelectAgreementStartDate(d) {
     saveAgreementStartDate();
   }

   function handleSelectAgreementEndDate(d) {
     saveAgreementEndDate();
   }

   function handleSelectPriceChangeDate(d) {
     savePriceChangeDate();
   }

   function saveAgreementStartDate() {
     var d = currentAgreementStartDateValue !== undefined && currentAgreementStartDateValue !== null ? new Date(currentAgreementStartDateValue) : null;
     if (d !== null) {
       let [date, month, year] = d.toLocaleDateString('en-NZ').split("/");
       setNewCustomer({
         ...newCustomer,
         agreement_start_date: `${year}-${month}-${date}`,
       });
       setSelectedAgreementStartDate(new Date(currentAgreementStartDateValue));
       currentAgreementStartDateValue = d;
     }
   }

   function saveAgreementEndDate() {
     var d = currentAgreementEndDateValue !== undefined && currentAgreementEndDateValue !== null ? new Date(currentAgreementEndDateValue) : null;
     if (d !== null) {
       let [date, month, year] = d.toLocaleDateString('en-NZ').split("/");
       setNewCustomer({
         ...newCustomer,
         agreement_end_date: `${year}-${month}-${date}`,
       });
       setSelectedAgreementEndDate(new Date(currentAgreementEndDateValue));
       currentAgreementEndDateValue = d;
     }
   }

   function savePriceChangeDate() {
     var d = currentPriceChangeDateValue !== undefined && currentPriceChangeDateValue !== null ? new Date(currentPriceChangeDateValue) : null;
     if (d !== null) {
       let [date, month, year] = d.toLocaleDateString('en-NZ').split("/");
       setNewCustomer({
         ...newCustomer,
         price_change_date: `${year}-${month}-${date}`,
       });
       setSelectedPriceChangeDate(new Date(currentPriceChangeDateValue));
       currentPriceChangeDateValue = d;
     }
   }

   function handleClose() {
     // nothing todo
   }

  return (
    <div className={classes.contentDiv}>
    {/*<div>{`props.createdCustomer is ${props.createdCustomer}`}</div>
    <div>{`props.createdCustomer.name is ${props.createdCustomer.name}`}</div>
    <div>{`props.createdCustomer.id is ${props.createdCustomer.id}`}</div>
    <div>{`newCustomer is ${newCustomer}`}</div>
    <div>{`newCustomer.name is ${newCustomer.name}`}</div>
    <div>{`newCustomer.id is ${newCustomer.id}`}</div>*/}

    <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog} disableBackdropClick={true}

        PaperProps={{
          style: {
            boxShadow: 'none',
          },
        }}
    >
      <DialogTitle className={classes.title}>Are you sure?</DialogTitle>
      <DialogContent>
        <DialogContentText>
           {`You are about to delete document ${aboutToDeleteDoc.name}.`}
        </DialogContentText>

      </DialogContent>
      <DialogActions>
          <Button onClick={handleCloseDeleteDialog}>
            Cancel
          </Button>
          <Button onClick={deleteDocument} disabled={isDeletingDocument}>
            {isDeletingDocument && <span><CircularProgress size={25} color={'inherit'} /> Deleting...</span>}
            {!isDeletingDocument && <span>DELETE</span>}
          </Button>
      </DialogActions>
    </Dialog>


    <form>
    {props.isNotesOnly === undefined &&
      <Box display={'flex'}
          justifyContent={'flex-end'}
          style={{marginBottom: '-20px', marginRight: '20px'}}
      >
          <Button style={{position: 'fixed', zIndex: '10'}}
              className={classes.updateCustomerButton}
              color="primary"
              disabled={disableSaveButton()}
              onClick={updateCustomer}
          >
          {isSaving && props.isNotesOnly === undefined && <span><CircularProgress size={25}/> Saving Customer...</span>}
          {isSaving && props.isNotesOnly && <span><CircularProgress size={25}/> Saving Customer Notes...</span>}
          {!isSaving && props.isNotesOnly === undefined && <span>Save Customer</span>}
          {!isSaving && props.isNotesOnly && <span>Save Customer Notes</span>}
          </Button>
      </Box>}
        <Grid container spacing={4}>
              {props.isNotesOnly === undefined &&
            <Grid item xs={12} md={6} sm={6}>

              <Widget
              title="Customer Details"
                upperTitle
                disableWidgetMenu
                showOverflow
              >
                <div className={classes.formDisplay}>
                <TextField
                  id="name"
                  label="Name"
                  autoComplete='off'
                  onChange={handleChange}
                  name="name"
                  value={newCustomer.name || ''}
                  variant="outlined"
                  required
                  error={newCustomer.name === ''}
                  helperText={newCustomer.name === '' ? 'Please enter the name of the customer.' : ' '}
                  size="small"
                />
                  <TextField
                    id="company"
                    label="Company"
                    autoComplete='off'
                    onChange={handleChange}
                    name="company"
                    value={newCustomer.company || ''}
                    variant="outlined"
                    style={{ marginBottom: 20 }}
                    size="small"
                  />

                  <div className={classes.industryDisplay}>
                    <FormControl
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      className={classnames({
                            'industrySelect':  true,
                            'industry-select-control': true
                          })}
                    >
                      <InputLabel shrink>Industry Category</InputLabel>
                      <div className={classnames({
                                    'industry-select-control-input': true
                                  })}>
                      <NativeSelect
                        value={newCustomer.industry_category_id || ''}
                        onChange={handleChange}
                        name="industry_category_id"
                      >
                        <option value=""> </option>
                        {industryCategories.map(category => (
                          <option key={category.id} value={category.id}>
                            {category.name}
                          </option>
                        ))}
                      </NativeSelect>
                      </div>
                    </FormControl>
                  </div>

                  <TextField
                    id="targetTagRatePerHour"
                    label="Target Tag Rate / Hour"
                    autoComplete="off"
                    onChange={handleChange}
                    name="target_tag_rate_per_hour"
                    value={newCustomer.target_tag_rate_per_hour || ''}
                    variant="outlined"
                    style={{ marginBottom: 20 }}
                    type="number"
                    size="small"
                  />


                  <AddressAutoComplete
                   label="Search Location"
                   presetValue={newCustomer.address}
                   onSelect={onSelectCustomerAddress}
                   onLocationUpdate={onGeoLocationFetched}/>


                  {props.inTab === undefined && <><TextField
                    id="notes"
                    name="notes"
                    label="Notes"
                    autoComplete='off'
                    value={newCustomer.notes || ''}
                    multiline
                    rows="5"
                    variant="outlined"
                    onChange={handleChange}
                    style={{ marginBottom: 20 }}
                    size="small"
                    InputProps={{
                      className: classes.textarea,
                    }}
                  />

                  <TextField
                    id="booking_instructions"
                    name="booking_instructions"
                    label="Booking Instructions"
                    autoComplete='off'
                    value={newCustomer.booking_instructions || ''}
                    multiline
                    rows="10"
                    variant="outlined"
                    onChange={handleChange}
                    style={{ marginBottom: 20 }}
                    size="small"
                    InputProps={{
                      className: classes.textarea,
                    }}
                  />

                  </>}

                  {/*<div className={classes.services}>
                    <SelectCustomerServices ref={selectCustomerServicesRef}
                                     isAddCustomer={false}
                                     customer={newCustomer}
                                     onServicesSelected={onServicesSelected}/>
                  </div>*/}

                  <div className={classes.testingScopes}>
                    <SelectCustomerTestingScopes ref={selectCustomerTestingScopesRef}
                                     required={true}
                                     isAddCustomer={false}
                                     customer={newCustomer}
                                     onTestingScopesSelected={onTestingScopesSelected}
                                     onOtherTestingScopesSpecified={onOtherTestingScopesSpecified}/>
                  </div>

                  <Box display="flex" alignItems="center">
                      <TrackChangesIcon
                          style={{ fontSize: 18, marginRight: 6, color: '#d4a017' }}
                      />
                      <Typography weight="medium">
                          KPI Customer
                      </Typography>

                      <Box ml="auto">
                          <Switch
                              color="primary"
                              checked={newCustomer.kpi_customer || false}
                              onClick={onClickKpiCustomerSwitch}
                          />
                      </Box>
                  </Box>

                  <Box display="flex" alignItems="center">
                    <VpnKeyIcon
                        style={{ fontSize: 18, marginRight: 6, color: '#d4a017' }}
                    />
                    <Typography weight="medium">
                        Key Customer
                    </Typography>

                    <Box ml="auto">
                        <Switch
                            color="primary"
                            checked={newCustomer.key_customer || false}
                            onClick={onClickKeyCustomerSwitch}
                        />
                    </Box>
                </Box>

                  <Box display={"flex"} alignItems={"center"}>
                      <Typography weight={"medium"}>
                          PO Required
                      </Typography>
                      <Switch color={"primary"} checked={newCustomer.po_required || false}
                              onClick={onClickPoRequiredSwitch} />
                  </Box>

                  <Box display={"flex"} alignItems={"center"}>
                      <Typography weight={"medium"}>
                          JSA Required
                      </Typography>
                      <Switch color={"primary"} checked={newCustomer.jsa_required || false}
                              onClick={onClickJSARequiredSwitch} />
                  </Box>

                  <Box display={"flex"} alignItems={"center"}>
                      <Typography weight={"medium"}>
                          No Microwave LKG
                      </Typography>
                      <Switch color={"primary"} checked={newCustomer.microwave_only || false}
                              onClick={onClickMicrowaveOnlySwitch} />
                  </Box>

                  <div className={classnames({
                                  [classes.section]: newCustomer !== null && newCustomer !== undefined && (newCustomer.service_level_agreement || false)
                                  })}>
                    <Box display={"flex"} alignItems={"center"}>
                        <Typography weight={"medium"}>
                            Service Level Agreement
                        </Typography>
                        <Switch color={"primary"} checked={newCustomer.service_level_agreement || false}
                                onClick={onClickServiceLevelAgreementSwitch} />
                    </Box>
                    { newCustomer !== null && newCustomer !== undefined && (newCustomer.service_level_agreement || false)  &&
                      <div className={classes.calendars} style={{ marginBottom: 20 }}>
                      <TextField
                        id="agreementStartDate"
                        ref={agreementStartDateRef}
                        style={{ marginTop: 10}}
                        label="Agreement Start Date"
                        required
                        className={classnames({
                        'textField': true,
                        'calenderField': true,
                        [classes.calendarFocused]: agreementStartDateFocused,
                        [classes.error]: selectedAgreementStartDate === null
                      })}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          startAdornment: (
                              <InputAdornment position="start">
                                <CalendarTodayIcon />
                              </InputAdornment>
                            ),
                            inputComponent: () =>
                            <DatePicker
                            ref={agreementStartDateCalendarRef}
                            className={classes.textField}
                            selected={selectedAgreementStartDate}
                            onSelect={handleSelectAgreementStartDate}
                            onChange={handleChangeAgreementStartDate}
                            onFocus={focusAgreementStartDate}
                            onClickOutside={blurAgreementStartDate}
                            onKeyDown={handleAgreementStartDateKeyPress}
                            locale="en-NZ"
                            dateFormat="dd/MM/yyyy"
                            />
                          }}
                          />

                        <TextField
                          id="agreementEndDate"
                          ref={agreementEndDateRef}
                          style={{ marginTop: 10}}
                          label="Agreement End Date"
                          required
                          className={classnames({
                          'textField': true,
                          'calenderField': true,
                          [classes.calendarFocused]: agreementEndDateFocused,
                          [classes.error]: selectedAgreementEndDate === null
                        })}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                  <CalendarTodayIcon />
                                </InputAdornment>
                              ),
                              inputComponent: () =>
                              <DatePicker
                              ref={agreementEndDateCalendarRef}
                              className={classes.textField}
                              selected={selectedAgreementEndDate}
                              onSelect={handleSelectAgreementEndDate}
                              onChange={handleChangeAgreementEndDate}
                              onFocus={focusAgreementEndDate}
                              onClickOutside={blurAgreementEndDate}
                              onKeyDown={handleAgreementEndDateKeyPress}
                              locale="en-NZ"
                              dateFormat="dd/MM/yyyy"
                              />
                            }}
                            />

                          </div>
                    }
                  </div>

                  { newCustomer !== null && newCustomer !== undefined &&
                  <div>
                      <TextField
                        id="priceChangeDate"
                        ref={priceChangeDateRef}
                        label="Price Change Date"
                        style={{ marginBottom: 20 }}
                        className={classnames({
                        'textField': true,
                        'calenderField': true,
                        [classes.calendarFocused]: priceChangeDateFocused,
                        [classes.error]: selectedPriceChangeDate === null
                      })}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          startAdornment: (
                              <InputAdornment position="start">
                                <CalendarTodayIcon />
                              </InputAdornment>
                            ),
                            inputComponent: () =>
                            <DatePicker
                            ref={priceChangeDateCalendarRef}
                            className={classes.textField}
                            selected={selectedPriceChangeDate}
                            onSelect={handleSelectPriceChangeDate}
                            onChange={handleChangePriceChangeDate}
                            onFocus={focusPriceChangeDate}
                            onClickOutside={blurPriceChangeDate}
                            onKeyDown={handlePriceChangeDateKeyPress}
                            locale="en-NZ"
                            dateFormat="dd/MM/yyyy"
                            />
                          }}
                          />
                  </div>
                  }

                  <Box display={"flex"} alignItems={"center"}>
                      <Typography weight={"medium"}>
                          Archived
                      </Typography>
                      <Switch color={"primary"} checked={!newCustomer.active}
                              onClick={onClickArchiveSwitch} />
                  </Box>

                </div>
            </Widget>

          </Grid>}
          {props.isNotesOnly === undefined &&  <Grid item xs={12} md={6} sm={6}>
            <Widget
              title="Contact"
              upperTitle
              disableWidgetMenu
              noMinHeight
            >
              <div className={classes.formDisplay}>
                <TextField
                  id="contact"
                  label="Contact"
                  autoComplete='off'
                  onChange={handleChange}
                  name="contact"
                  value={newCustomer.contact || ''}
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AssignmentIndIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  id="phone"
                  label="Phone"
                  autoComplete='off'
                  onChange={handleChange}
                  name="phone"
                  value={newCustomer.phone || ''}
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PhoneIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  id="mobile"
                  label="Mobile"
                  onChange={handleChange}
                  name="mobile"
                  autoComplete='off'
                  value={newCustomer.mobile || ''}
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SmartphoneIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  id="email"
                  label="Email"
                  autoComplete='off'
                  onChange={handleChange}
                  value={newCustomer.email || ''}
                  name="email"
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  type={'email'}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  id="repairEmail"
                  label="Repair Email"
                  autoComplete='off'
                  onChange={handleChange}
                  value={newCustomer.repair_email || ''}
                  name="repair_email"
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  type={'email'}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  id="healthSafetyEmail"
                  label="Health & Safety Contact Email"
                  autoComplete='off'
                  onChange={handleChange}
                  value={newCustomer.health_safety_email || ''}
                  name="health_safety_email"
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  type={'email'}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                  }}
                />


              </div>
            </Widget>

            <Widget
              title="Billing Contact"
              upperTitle
              disableWidgetMenu
              noMinHeight
              style={{marginTop:'20px'}}
            >
              <div className={classes.formDisplay}>
                <TextField
                  id="billing_contact"
                  label="Billing Contact"
                  autoComplete='off'
                  onChange={handleChange}
                  name="billing_contact"
                  value={newCustomer.billing_contact || ''}
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AssignmentIndIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  id="biling_phone"
                  label="Billing Phone"
                  autoComplete='off'
                  onChange={handleChange}
                  name="billing_phone"
                  value={newCustomer.billing_phone || ''}
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PhoneIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  id="billing_mobile"
                  label="Billing Mobile"
                  onChange={handleChange}
                  name="billing_mobile"
                  autoComplete='off'
                  value={newCustomer.billing_mobile || ''}
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SmartphoneIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  id="billing_email"
                  label="Billing Email"
                  autoComplete='off'
                  onChange={handleChange}
                  value={newCustomer.billing_email || ''}
                  name="billing_email"
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  type={'email'}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                  }}
                />

              </div>
            </Widget>
            <Widget
              title="Failed Report"
              upperTitle
              disableWidgetMenu
              noMinHeight
              style={{marginTop:'20px'}}
            >
                <Box display={"flex"} alignItems={"center"}>
                    <Typography weight={"medium"}>
                        Auto Failed Report
                    </Typography>
                    <Switch color={"primary"} checked={newCustomer.auto_failed_report}
                            onClick={onClickAutoFailedReportSwitch} />
                </Box>

                <div className={classes.formDisplay}>
                  <TextField
                    id="failed_report_email"
                    label="Failed Report Email"
                    autoComplete='off'
                    onChange={handleChange}
                    value={newCustomer.failed_report_email || ''}
                    name="failed_report_email"
                    variant="outlined"
                    style={{ marginBottom: 20 }}
                    type={'email'}
                    size="small"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EmailIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>

            </Widget>
            {/*<Widget
              title="Vaccination"
              upperTitle
              disableWidgetMenu
              style={{marginTop:'20px'}}
              noMinHeight>
                  <Box display={"flex"} alignItems={"center"}>
                      <Typography weight={"medium"}>
                          Proof of vaccination required
                      </Typography>
                      <Switch color={"primary"} checked={newCustomer.require_vaccination_proof || false}
                              onClick={onClickRequireVaccinationProofSwitch} />
                  </Box>

                  <TextField
                    id="covid_policy"
                    name="covid_policy"
                    label="COVID Policy"
                    autoComplete='off'
                    value={newCustomer.covid_policy || ''}
                    multiline
                    rows="10"
                    variant="outlined"
                    onChange={handleChange}
                    style={{ marginBottom: 20, width: '100%', marginTop: 20 }}
                    size="small"
                    InputProps={{
                      className: classes.textarea,
                    }}
                  />

            </Widget>*/}
          </Grid>}

          <Grid item xs={12} md={12} sm={12}>
              <Widget
                title="Custom Properties"
                upperTitle
                className={classes.card}
                bodyClass={classes.fullHeightBody}
                disableWidgetMenu
                showOverflow
              >
                  <CustomProperties customerProperties={newCustomer.custom_properties || null}
                                    enableCustomProperties={newCustomer.enable_custom_properties || false}
                                    onCustomerPropertiesChanged={onCustomerPropertiesChanged}
                                    onCustomPropertiesEnableChanged={onCustomPropertiesEnableChanged}/>
              </Widget>
          </Grid>
          {props.isNotesOnly === undefined && <Grid item xs={12} md={12} sm={12}>
              <Widget
                title="Documents"
                upperTitle
                className={classes.card}
                bodyClass={classes.fullHeightBody}
                disableWidgetMenu
              >
              <div className={classes.documentsDisplay}>
              <div>
                <Box mb={3}>
                <Typography variant="subtitle1" style={{ marginBottom: 8 }}>
                  Customer Policy
                </Typography>

                <Button onClick={openCustomerPolicyDialog}>
                  <Box mr={1} display="flex">
                    <DescriptionIcon />
                  </Box>
                  Manage Customer Policy
                </Button>
                </Box>

                <Box mb={3} pt={2} style={{ borderTop: '1px solid #e0e0e0' }}>
                <Grid container spacing={4}>
                  <Grid item xs={12} md={5}>
                    <Typography variant="subtitle1" style={{ marginBottom: 8 }}>
                       Uploaded Customer Policy PDF
                    </Typography>

                    {newCustomer.has_policy && (
                      <Box mb={1} className={classes.policyLinkBox}>
                        <Link href={`${config.clientApi}/policy?cid=${newCustomer.id}`} target="_blank" underline="none" color="#fff">
                          <Button>
                            <Box mr={1} display="flex">
                              <PictureAsPdfIcon />
                            </Box>
                            View Site Policy
                            <Box ml={1} display="flex">
                              <GetAppIcon />
                            </Box>
                          </Button>
                        </Link>
                      </Box>
                    )}

                    <DropzoneArea
                        filesLimit={1}
                        showFileNames={true}
                        acceptedFiles={['application/pdf']}
                        dropzoneText={"Drag and drop the final customer policy PDF generated from the policy template."}
                        onChange={newFileObjs => {
                            setFileObjects(newFileObjs);
                        }}
                        onDelete={() => {
                            setFileObjects([]);
                        }}
                        maxFileSize={2097152}
                    />

                    {fileObjects !== undefined && fileObjects !== null && fileObjects.length > 0 && (
                      <Box mt={1}>
                        <Typography variant="body2" style={{ marginBottom: 8 }}>
                          Selected: {fileObjects[0].name}
                        </Typography>

                        <Button onClick={onUploadSitePolicy}>
                          <Box mr={1} display="flex">
                            <PublishIcon />
                          </Box>
                          {isUploading && <span><CircularProgress size={25}/> Uploading site policy...</span>}
                          {!isUploading && <span>Upload Site Policy</span>}
                        </Button>
                      </Box>
                    )}
                  </Grid>

                  <Grid item xs={12} md={7}>
                    <Typography variant="subtitle1" style={{ marginBottom: 8 }}>
                      Other Documents
                    </Typography>

                    {newCustomer.documents !== undefined && newCustomer.documents !== null && newCustomer.documents.length > 0 && (
                      <>
                        {newCustomer.documents.map((document) => (
                          <Fragment key={document.id}>
                            <Box>
                              <Link href={`${config.clientApi}/dashboard/customer_documents?id=${document.id}`} target="_blank" underline="none" color="#fff">
                                <Button>
                                  <Box mr={1} display="flex">
                                    <PictureAsPdfIcon />
                                  </Box>
                                  {document.title}
                                  <Box ml={1} display="flex">
                                    <GetAppIcon />
                                  </Box>
                                </Button>
                              </Link>
                              <IconButton color="inherit" onClick={() => onDeleteDocument(document.id)}>
                                <DeleteIcon />
                              </IconButton>
                            </Box>
                          </Fragment>
                        ))}
                        <br/>
                      </>
                    )}

                    <DropzoneArea
                      filesLimit={otherDocumentsLimit}
                      showFileNames={true}
                      dropzoneText={"Drag and drop other documents here or click. Maximum of 2 files."}
                      onChange={newFileObjs => setFileObjectsOther(newFileObjs)}
                      onDelete={() => setFileObjectsOther([])}
                      maxFileSize={2097152}
                      useChipsForPreview
                      showPreviewsInDropzone={false}
                      previewGridProps={{container: { spacing: 1, direction: 'row' }}}
                      previewText="Selected files"
                      showPreviews={true}
                    />

                    {fileObjectsOther !== undefined && fileObjectsOther !== null &&
                      fileObjectsOther.length > 0 && !hideOtherDocumentsUploadButton() && (
                        <Button style={{marginTop: '10px'}} onClick={onUploadOtherDocuments}>
                          <Box mr={1} display="flex">
                            <PublishIcon />
                          </Box>
                          {isUploadingOther && <span><CircularProgress size={25}/> Uploading other documents...</span>}
                          {!isUploadingOther && <span>Upload Other Documents</span>}
                        </Button>
                      )}
                  </Grid>
                </Grid>
                </Box>
                </div>
              </div>

                </Widget>
                </Grid>}
          {props.isNotesOnly === undefined && <Grid item xs={12} md={12} sm={12}>
              <Widget
                title="Pricing"
                upperTitle
                className={classes.card}
                bodyClass={classes.fullHeightBody}
                ref={customerPricingWidgetRef}
                menuItems={<div>
                           <MenuItem onClick={downloadPricingHistory}>
                               <HistoryIcon/><Typography>Download Pricing History</Typography>
                           </MenuItem>
                           {newCustomer.service_level_agreement && <MenuItem onClick={updateCustomerPricingWithCPI}>
                               <PublishIcon/><Typography>Adjust Pricing Based on CPI</Typography>
                           </MenuItem>}
                           </div>
                         }
              >
                <div className={classes.pricingDisplay}>
                    <FormControl variant="outlined" className={classnames({
                          'chargeBySelect':  true,
                          'chargeby-select-control': true
                        })}>
                      <InputLabel>Charge By</InputLabel>
                      <div className={classnames({
                                    'chargeby-select-control-input': true
                                  })}>
                        <NativeSelect
                          value={selectedChargeBy}
                          onChange={handleChangeSelectChargeBy}
                        >
                           <option value="Tag">Tag</option>
                           <option value="Hour">Hour</option>
                        </NativeSelect>
                      </div>
                    </FormControl>
                    {selectedChargeBy === 'Hour' && <TextField
                      id="hourlyCharge"
                      label="Hourly Charge"
                      onChange={handleChange}
                      value={newCustomer.hourly_charge === undefined || newCustomer.hourly_charge === null || newCustomer.hourly_charge <= 0 ? newCustomer.default_hourly_charge : newCustomer.hourly_charge}
                      name="hourly_charge"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />}

                    <TextField
                      id="minCharge"
                      label="Min Charge"
                      onChange={handleChange}
                      value={newCustomer.min_charge}
                      name="min_charge"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="minCashCharge"
                      label="Min Cash Charge"
                      onChange={handleChange}
                      value={newCustomer.min_cash_charge}
                      name="min_cash_charge"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="localTravel"
                      label="Local Travel"
                      onChange={handleChange}
                      value={newCustomer.local_travel}
                      name="local_travel"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="seventyHundredTravel"
                      label="Travel 60 - 100km"
                      onChange={handleChange}
                      value={newCustomer.seventy_hundred_travel}
                      name="seventy_hundred_travel"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="over100Travel"
                      label="Region Travel > 100km"
                      onChange={handleChange}
                      value={newCustomer.over_100_travel}
                      name="over_100_travel"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />
                    {selectedChargeBy === 'Tag' && <><TextField
                      id="singlePhasePrice"
                      label="Single Phase Price"
                      onChange={handleChange}
                      value={newCustomer.single_phase_price}
                      name="single_phase_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />
                    <TextField
                      id="threePhasePrice"
                      label="Three Phase Price"
                      onChange={handleChange}
                      value={newCustomer.three_phase_price}
                      name="three_phase_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />
                    <TextField
                      id="rcdPrice"
                      label="RCD Price"
                      onChange={handleChange}
                      value={newCustomer.rcd_price}
                      name="rcd_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="firePrice"
                      label="Fire Price"
                      onChange={handleChange}
                      value={newCustomer.fire_price}
                      name="fire_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="fistAidPrice"
                      label="First Aid Price"
                      onChange={handleChange}
                      value={newCustomer.first_aid_price}
                      name="first_aid_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="medicalPrice"
                      label="Medical Price"
                      onChange={handleChange}
                      value={newCustomer.medical_price}
                      name="medical_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="rcdPbPrice"
                      label="RCD PB Price"
                      onChange={handleChange}
                      value={newCustomer.rcd_pb_price}
                      name="rcd_pb_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="lgPbPrice"
                      label="LG PB Price"
                      onChange={handleChange}
                      value={newCustomer.lg_pb_price}
                      name="lg_pb_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="lgMPrice"
                      label="LG6 Measured Price"
                      onChange={handleChange}
                      value={newCustomer.lg_m_price}
                      name="lg_m_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="threePhaseRcdPrice"
                      label="3 Phase RCD Price"
                      onChange={handleChange}
                      value={newCustomer.three_phase_rcd_price}
                      name="three_phase_rcd_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="microwavePrice"
                      label="Microwave Price"
                      onChange={handleChange}
                      value={newCustomer.microwave_price}
                      name="microwave_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="nonElectricalPrice"
                      label="Non Electrical Price"
                      onChange={handleChange}
                      value={newCustomer.non_electrical_price}
                      name="non_electrical_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="ladderPrice"
                      label="Ladder Price"
                      onChange={handleChange}
                      value={newCustomer.ladder_price}
                      name="ladder_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="aedPrice"
                      label="AED Price"
                      onChange={handleChange}
                      value={newCustomer.aed_price}
                      name="aed_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="evsePrice"
                      label="EVSE Price"
                      onChange={handleChange}
                      value={newCustomer.evse_price}
                      name="evse_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    /></>}
                </div>
              </Widget>
          </Grid>}

          {props.isNotesOnly && <><TextField
            id="customer_notes_only"
            name="notes"
            label="Notes"
            autoComplete='off'
            value={newCustomer.notes || ''}
            multiline
            rows="5"
            variant="outlined"
            onChange={handleChange}
            style={{ marginBottom: 20, width: '100%', marginTop: 20 }}
            size="small"
            InputProps={{
              className: classes.textarea,
            }}
          />

          <TextField
            id="customer_booking_instructions_only"
            name="booking_instructions"
            label="Booking Instructions"
            autoComplete='off'
            value={newCustomer.booking_instructions || ''}
            multiline
            rows="10"
            variant="outlined"
            onChange={handleChange}
            style={{ marginBottom: 20, width: '100%', marginTop: 20 }}
            size="small"
            InputProps={{
              className: classes.textarea,
            }}
          />

          </>}

          <div className={classes.bottomMenu}>
              <div>
              <Box
                  display={'flex'}
                  justifyContent={'flex-end'}
              >
                  <Button className={classes.updateCustomerButton}
                      color="primary"
                      disabled={disableSaveButton()}
                      onClick={updateCustomer}
                  >
                  {isSaving && <span><CircularProgress size={25}/> Saving...</span>}
                  {!isSaving && props.isNotesOnly === undefined && <span>Save Customer</span>}
                  {!isSaving && props.isNotesOnly && <span>Save Customer Notes</span>}
                  </Button>
              </Box>
              </div>
          </div>
        </Grid>

      </form>

      <Dialog
        open={customerPolicyDialogOpen}
        onClose={closeCustomerPolicyDialog}
        disableBackdropClick={true}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          style: {
            boxShadow: 'none',
            width: '100%'
          },
        }}
      >
        <DialogTitle className={classes.title}>CUSTOMER POLICY</DialogTitle>
        <DialogContent>
          <CustomerPolicyEditor customer={newCustomer} onClose={closeCustomerPolicyDialog} />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeCustomerPolicyDialog}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <CustomerUpdatePricingWithCPI ref={customerUpdatePricingWithCPIRef} closeMenu={handleClose} onUpdateSuccess={refreshCustomer}/>
    </div>
  );
//}
});
export default UpdateCustomer;
